"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _router = _interopRequireDefault(require("./router"));
var _elementUi = require("element-ui");
var _store = _interopRequireDefault(require("./store"));
var _nprogress = _interopRequireDefault(require("nprogress"));
require("nprogress/nprogress.css");
var _auth = require("@/utils/auth");
var _getPageTitle = _interopRequireDefault(require("@/utils/get-page-title"));
var _permission = require("./utils/permission");
var _settings = require("@/settings");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _vuexModuleDecorators = require("vuex-module-decorators");
var _user = _interopRequireDefault(require("./store/modules/user"));
// progress bar
// progress bar style
// get token from cookie

var language = _jsCookie.default.get("language") || "vi";
_nprogress.default.configure({
  showSpinner: false
}); // NProgress Configuration
var whiteList = ["/login", "/auth-redirect", "/404", "/chart", "/forget", '/playback']; // no redirect whitelist
_router.default.beforeEach( /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(to, from, next) {
    var hasToken, userStore, accessRoute;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // start progress bar
          _nprogress.default.start();
          // set page title
          // document.title = getPageTitle(messages[language][to.meta.title] ?? to.meta.title);
          document.title = (0, _getPageTitle.default)(to.meta.title);
          // determine whether the user has logged in
          hasToken = (0, _auth.getToken)();
          if (!hasToken) {
            _context.next = 37;
            break;
          }
          userStore = (0, _vuexModuleDecorators.getModule)(_user.default, _store.default);
          if (!(to.path === "/login")) {
            _context.next = 10;
            break;
          }
          // if is logged in, redirect to the home page
          next({
            path: "/"
          });
          _nprogress.default.done();
          _context.next = 35;
          break;
        case 10:
          if (!(whiteList.indexOf(to.path) !== -1)) {
            _context.next = 14;
            break;
          }
          next();
          _context.next = 35;
          break;
        case 14:
          _context.prev = 14;
          _context.next = 17;
          return userStore.getInfo();
        case 17:
          if (!_settings.checkPermission) {
            _context.next = 24;
            break;
          }
          _context.next = 20;
          return _store.default.dispatch("permission/setRoutesAccess");
        case 20:
          accessRoute = (0, _permission.checkAccessRoute)(to.path);
          if (accessRoute === true || to.meta.permission == false) {
            next();
          } else {
            next(accessRoute);
          }
          _context.next = 25;
          break;
        case 24:
          next();
        case 25:
          _context.next = 35;
          break;
        case 27:
          _context.prev = 27;
          _context.t0 = _context["catch"](14);
          console.log('error router', _context.t0);
          _context.next = 32;
          return userStore.resetToken();
        case 32:
          _elementUi.Message.error(_context.t0 || "Has Error");
          next("/login?redirect=".concat(to.path));
          _nprogress.default.done();
        case 35:
          _context.next = 38;
          break;
        case 37:
          /* has no token*/
          if (whiteList.indexOf(to.path) !== -1 || to.meta.permission === false) {
            // in the free login whitelist, go directly
            next();
          } else {
            // other pages that do not have permission to access are redirected to the login page.
            next("/login?redirect=".concat(to.path));
            _nprogress.default.done();
          }
        case 38:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[14, 27]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
_router.default.afterEach(function () {
  // finish progress bar
  _nprogress.default.done();
});